import { Row } from "antd";
import React, { useEffect, useState } from "react";
import HeroTitle from "./HeroTitle";
import HeroTitleData from "./../../../../Assets/JsonData/HeroTitleData.json";
// import HeroImage from './HeroImage';

const Hero = () => {
  const [heroTitles, setHeroTitles] = useState(HeroTitleData);

  useEffect(() => {
    setHeroTitles(heroTitles);
  }, [heroTitles]);

  return (
    <div className="heroBg">
      <Row
        justify="center"
        align="middle"
        style={{ textAlign: "center", height: "95vh" }}
      >
        {heroTitles.map((heroTitle) => (
          <HeroTitle heroTitle={heroTitle} key={heroTitle.id} />
        ))}
        {/* <HeroImage /> */}
      </Row>
    </div>
  );
};

export default Hero;
